module.exports = {
    "logo_type_link": {
        "yandex": "Яндекс"
    }
};